/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const DatabaseTask = core.serialization.object({
    status: core.serialization.string(),
    type: core.serialization.string(),
    progress: core.serialization.number(),
});
